import { getCustomFieldOptions } from "@forgepoint/shared";
import {
  FilterMultiSelectContent,
  type FilterMultiSelectItem,
} from "@/components/filters/FilterMultiSelectContent";
import {
  isUserCustomField,
  type FilterableCustomField,
} from "@/lib/customFieldFilters";
import { getUserDisplayName, useTeamsStore } from "@/store/teamsStore";

interface CustomFieldFilterContentProps {
  field: FilterableCustomField;
  selected: string[];
  onChange: (next: string[]) => void;
}

/**
 * Dropdown body for a custom field filter: a searchable multi-select of the
 * field's options, or of org members for user fields.
 */
export function CustomFieldFilterContent({
  field,
  selected,
  onChange,
}: CustomFieldFilterContentProps) {
  const users = useTeamsStore((state) => state.users);
  const isUserField = isUserCustomField(field);

  const items: FilterMultiSelectItem[] = isUserField
    ? users.map((user) => ({ id: user.id, name: getUserDisplayName(user) }))
    : (getCustomFieldOptions(field.property) ?? []).map((option) => ({
        id: option,
        name: option,
      }));

  return (
    <FilterMultiSelectContent
      items={items}
      selected={selected}
      onChange={onChange}
      placeholder={isUserField ? "Search people..." : "Search options..."}
      emptyText={isUserField ? "No people found." : "No options found."}
    />
  );
}
